/**
 * B2C password-reset policy authority.
 * Prefer explicit env; if missing at build time, derive from SUSI authority using
 * the common custom-policy naming pattern (miraxis tenants).
 */
function buildPasswordResetAuthority() {
  const explicit = process.env.REACT_APP_AZURE_AD_AUTHORITY_RESET;
  if (explicit && String(explicit).trim()) {
    return String(explicit).trim();
  }
  const susi = process.env.REACT_APP_AZURE_AD_AUTHORITY;
  if (
    susi &&
    typeof susi === "string" &&
    susi.includes("B2C_1A_TRUSTFRAMEWORKBASE_SUSI")
  ) {
    return susi.replace(
      /B2C_1A_TRUSTFRAMEWORKBASE_SUSI/gi,
      "B2C_1A_PASSWORDRESET",
    );
  }
  return "";
}

export const passwordResetAuthority = buildPasswordResetAuthority();
